import SalesReport from './SalesReportRenderer';

export default SalesReport;



// WEBPACK FOOTER //
// /src/components/Reports/Sales/index.js